import React, { useState } from 'react'
import { styled } from 'styled-components'
import PropTypes from 'prop-types'
import { Select } from 'antd'
import { omit } from 'lodash'

const CustomFormSelect = styled(Select)`
  & input {
    cursor: pointer !important;
  }
`

const CustomSelect = (props) => {
  const [search, setSearch] = useState('')
  const cleanedProps = omit(props, 'entries')
  const allOptions = (props.entries || []).map(({ iso, name }) => ({ label: name, value: iso }))
  const options = search
    ? allOptions.filter((o) => o.label.toLowerCase().includes(search.toLowerCase()))
    : allOptions

  return (
    <CustomFormSelect
      {...cleanedProps}
      autoComplete="none"
      options={options}
      showSearch={{ filterOption: false, onSearch: (val) => setSearch(val || '') }}
    />
  )
}

CustomSelect.propTypes = {
  entries: PropTypes.array.isRequired,
  onChange: PropTypes.func,
}

export default CustomSelect
